module.exports = __webpack_public_path__ + "img/pause-solid.dcc3bb8d.svg";